import dayjs from "dayjs";
import { saveAs } from "file-saver";
import _ from "lodash";
import * as XLSX from "xlsx";

// import { formatDuration } from "./formatDuration";

export const exportPrediction = async ({ data }) => {
  const formattedData = _.map(data, (item) => {
    return {
      "File Name": _.get(item, ["fileName"]),
      Times: _.get(item, ["times"]),
      "Total Duration": _.get(item, ["totalDuration"]),
    };
  });

  const suffixName = dayjs().format("DD-MM-YYYY-HH-mm-ss");
  const fileName = `prediction_${suffixName}.xlsx`;
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Prediction");

  worksheet["!cols"] = [{ wch: 30 }, { wch: 25 }, { wch: 20 }];

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, fileName);
};
